export default __webpack_public_path__ + "locales/ru/FilesSettings.json?hash=85faadeda45460faf87f8d4aacf8ddea";